<template>
  <div class="app-container">
    <!-- 顶部菜单栏 -->
    <TopMenu />

    <div class="main-content">
      <!-- 左侧菜单栏 -->
      <SideMenu @menu-click="handleMenuClick" />

      <!-- 右侧动态内容 -->
      <div class="content-area">
        <DynamicContent :component="currentComponent" />
      </div>
    </div>
    <!-- 底部备案信息 -->
    <div class="footer">
      <p>© 2025 个人版权所有 | 备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2024353179号-2</a></p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import TopMenu from '../components/TopMenu.vue'
import SideMenu from '../components/SideMenu.vue'
import DynamicContent from '../components/DynamicContent.vue'
import IndexView from './IndexView.vue'

export default {
  components: {
    TopMenu,
    SideMenu,
    DynamicContent
  },
  setup() {
    const currentComponent = ref(IndexView)

    const handleMenuClick = (component) => {
      currentComponent.value = component
    }

    return {
      currentComponent,
      handleMenuClick
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: #3498db;
  transition: all 0.3s ease;
}

a:hover {
  color: #e74c3c;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.content-area {
  flex: 1;
  width: 85%;
  overflow-y: auto;
  background-color: #f5f5f5;
}

/* 底部备案信息样式 */
.footer {
  height: 40px;
  background-color: #f8f8f8;
  border-top: 1px solid #e7e7e7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #666;
}
</style>